// extracted by mini-css-extract-plugin
module.exports = {"intro":"intro_intro__1YRR3","heading":"intro_heading__3RTTA","text":"intro_text__2y_9Y"};